import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { AssetAssignment } from "../entity/asset-assignment.entity";


@Injectable()
@EntityRepository(AssetAssignment)
export class AssetAssignmentRepository extends Repository<AssetAssignment>{
    
}